import React from 'react';
import ReactDOM from 'react-dom';
import Root from './containers/Root';
import { BrowserRouter  } from 'react-router-dom';


import store from './store';

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <Root store={store} />
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);
